import { useQuery } from '@tanstack/react-query';
import type { AuditEntry } from '@peles/shared';
import * as auditApi from '../api/audit';

export function useEntityAudit(entityType: string, entityId: string, enabled: boolean = true) {
  return useQuery<AuditEntry[]>({
    queryKey: ['audit', entityType, entityId],
    queryFn: () => auditApi.getEntityAudit(entityType, entityId),
    enabled: enabled && !!entityType && !!entityId,
  });
}
